<template>
  <v-app-bar
    app
    flat
    height="fit-content"
    color="#ffffff"
    class="nav-bar"
    id="navbar"
    absolute
  >
    <v-container fluid class="nav-bar">
      <v-row align="center" justify="space-between">
        <!-- Logo Section -->
        <v-col cols="4" class="d-flex align-center">
          <img
            src="@/assets/logo.png"
            alt="Logo"
            @click="$router.push({ name: 'home' })"
            style="cursor: pointer"
            class="logo"
          />
        </v-col>

        <!-- Search Bar Section -->
        <v-col cols="4" class="d-flex justify-center position-relative">
          <input
            v-model="searchQuery"
            type="search"
            name="navsearch"
            id="navsearch"
            style="
              width: 100%;
              height: 50px;
              border-radius: 30px;
              outline: none;
              background-color: #fff;
              border: 1px solid #e9e9e9;
            "
            :placeholder="placeholderText"
            dir="rtl"
            class="py-2 px-5"
            @keyup.enter="redirectToSearch"
          />
          <v-icon
            style="position: absolute; left: 26px; top: 36%"
            @click="redirectToSearch"
          >
            mdi-magnify
          </v-icon>
        </v-col>

        <!-- Cart and Contact Section -->
        <v-col
          cols="4"
          class="d-flex justify-end align-center"
          style="gap: 10px"
        >
          <v-btn icon variant="text" @click="openCart" aria-label="Cart">
            <v-badge
              :content="itemsCount"
              :model-value="itemsCount > 0"
              color="red"
            >
              <v-icon size="28">mdi-cart-outline</v-icon>
            </v-badge>
          </v-btn>
          <v-btn
            text
            class="action-link"
            @click="$router.push({ name: 'contact_us' })"
          >
            للتواصل معنا
          </v-btn>
        </v-col>
      </v-row>

      <!-- Category Links Section -->
      <v-row justify="center">
        <v-col cols="8" class="d-flex justify-center">
          <div class="navlist d-flex justify-center" dir="rtl">
            <span class="nav-link" v-for="cat in categories" :key="cat.title">
              <router-link
                :to="{
                  name: 'products_category',
                  query: { category: cat.route, title: cat.title },
                }"
                style="color: #333333; text-decoration: none"
              >
                {{ cat.title }}
              </router-link>
            </span>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-app-bar>
</template>

<script>
import { useProductsModule } from "@/stores/products";
import { useCartModule } from "@/stores/cart";
import { mapState } from "pinia";
import { ref, watch } from "vue";
import { useRouter, useRoute } from "vue-router";

export default {
  inject: ["Emitter"],
  methods: {
    openMenu() {
      this.Emitter.emit("openMenu");
    },
    openCart() {
      this.Emitter.emit("openCart");
    },
  },
  computed: {
    ...mapState(useProductsModule, ["categories"]),
    ...mapState(useCartModule, ["itemsCount"]),
  },
  setup() {
    const searchQuery = ref("");
    const placeholderText = ref("البحث عن المنتجات..."); // Define placeholder text
    const router = useRouter();
    const route = useRoute(); // Get the current route

    const redirectToSearch = () => {
      if (searchQuery.value.trim()) {
        // Ensure no empty query
        // Redirect to the search results page with the query
        router.push({
          name: "searchResults",
          query: { q: searchQuery.value.trim() },
        });
      }
    };

    // Watch for changes in the route and clear search query if navigating away from search results
    watch(
      () => route.name,
      (newRouteName) => {
        if (newRouteName !== "searchResults") {
          // Clear search query when navigating away from the search results page
          searchQuery.value = "";
        }
      }
    );

    return {
      searchQuery,
      placeholderText,
      redirectToSearch,
    };
  },
};
</script>
<style scoped>
@import url("https://fonts.google.com/noto/specimen/Noto+Kufi+Arabic?lang=ar_Arab");
/* Navbar Styles */
.nav-bar {
  color: black;
  background-color: transparent;
  background-size: cover;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  transition: top 0.3s ease-in-out;
}
.logo {
  height: 65px;
  max-width: 100%;
  margin-left: 8px;
}
input[type="search"] {
  width: 100%;
  height: 50px;
  border-radius: 30px;
  outline: none;
  background-color: #ffffff;
  border: 1px solid #e9e9e9;
  transition: border-color 0.3s ease, box-shadow 0.3s ease, transform 0.3s ease;
}
input[type="search"]:focus {
  border-color: #4a90e2;
  box-shadow: 0 0 5px rgba(228, 186, 0, 0.76);
  transform: scale(1.01);
}
.action-link {
  font-size: 14px;
  color: #4a4a4a;
  margin-right: 10px;
  font-family: "Noto Kufi Arabic", sans-serif;
  font-weight: bold;
}
.navlist {
  display: flex;
  gap: 20px;
}
.nav-link {
  font-size: 16px;
  font-weight: bold;
  color: #333333;
  padding-bottom: 5px;
  position: relative;
  cursor: pointer;
  font-family: "Noto Kufi Arabic", sans-serif;
}
.nav-link::after {
  content: "";
  position: absolute;
  bottom: -5px;
  left: 0;
  width: 0;
  height: 2px;
  background-color: #916811;
  transition: width 0.3s ease-in-out, bottom 0.3s ease-in-out;
}
.nav-link:hover::after {
  width: 100%;
  bottom: 0;
}
</style>
